import { SupportedChainId } from 'src/config/networks'
import useActiveOrDefaultChain from './useActiveOrDefaultChain'

const chainFeatures = {
  goldNfts: [
    SupportedChainId.Polygon,
    SupportedChainId.Mainnet,
    SupportedChainId.Base,
    SupportedChainId.ArbitrumSepolia,
  ],
  xGold: [SupportedChainId.Mainnet, SupportedChainId.ArbitrumSepolia],
  tradeOptions: [
    SupportedChainId.Polygon,
    SupportedChainId.Mainnet,
    SupportedChainId.Base,
    SupportedChainId.ArbitrumSepolia,
  ],
} as const

type ChainFeature = keyof typeof chainFeatures

export const useChainFeatures = () => {
  const chain = useActiveOrDefaultChain()

  const checkSupported = (feature: ChainFeature): boolean => {
    return chainFeatures[feature]?.includes(chain.id) ?? false
  }

  const features = Object.keys(chainFeatures).reduce(
    (acc, feature) => ({
      ...acc,
      [feature]: checkSupported(feature as ChainFeature),
    }),
    {} as Record<ChainFeature, boolean>
  )

  return { features }
}
